// @flow
import type { TasksState } from "./types";
import { startRequest, finishRequest } from "@store/utils";

export const setLoading = (state: TasksState) => () => startRequest(state);

export const setLoaded = (state: TasksState) => ({ payload }: Object) => finishRequest(state);

export const setError = (state: TasksState) => ({ payload }: Object) => ({
  ...finishRequest(state),
  error: payload,
});

export const onGetAbsenceTaskSchemaSuccess = (state: TasksState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    schemas: {
      ...state.schemas,
      absenceTask: payload,
    },
  };
};

export const onGetOutstandingTasksSuccess = (state: TasksState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    myTasks: payload,
  };
};

export const onGetAbsenceTaskSuccess = (state: TasksState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    myTasks: {
      ...state.myTasks,
      selectedTask: payload,
    },
  };
};

export const onGetRtwInterviewTaskSuccess = (state: TasksState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    myTasks: {
      ...state.myTasks,
      selectedTask: payload,
    },
  };
};

export const onSetRtwInterviewTaskHistory = (state: TasksState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    myTasks: {
      ...state.myTasks,
      selectedTaskHistory: payload,
    },
  };
};

export const onToggleLateSubmissionModal = (state: TasksState) => ({ payload }: Object) => {
  return {
    ...state,
    modals: {
      ...state.modals,
      showLateSubmissionModal: payload,
    },
  };
};

export const onGetManagerLedReferralTaskSuccess = (state: TasksState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    myTasks: {
      ...state.myTasks,
      selectedTask: payload,
    },
  };
};

export const onSetMyTasksSearch = (state: TasksState) => ({ payload }: Object) => {
  return {
    ...state,
    search: {
      ...state.search,
      employee: payload,
    },
  };
};

export const onSetMyTasksType = (state: TasksState) => ({ payload }: Object) => {
  return {
    ...state,
    search: {
      ...state.search,
      type: payload,
    },
  };
};
